import { api } from '../lib/gapApi';

export const getSolutions = async () => {
  const response = await api.get('/solutions');
  return response.data;
};

export const getRecommendedServices = async (analysisId) => {
  const response = await api.get(`/analysis/${analysisId}/recommended-services`);
  return response.data;
};

export const getPricing = async (analysisId) => {
  const response = await api.get(`/analysis/${analysisId}/pricing`);
  return response.data;
};

export const approveProposal = async (proposalId) => {
  const response = await api.post(`/proposal/${proposalId}/approve`);
  return response.data;
};

export const requestRevision = async (proposalId, feedback) => {
  const response = await api.post(`/proposal/${proposalId}/request-revision`, { feedback });
  return response.data;
};
